import {
  SituacaoUpload,
  TipoDocumentoAluno,
  TipoDocumentoAlunoCertificacao,
  TipoDocumentoCursoCertificacao,
  TipoDocumentoParceiroCertificacao,
  TipoDocumentoProfessor,
  TipoDocumentoProfessorCertificacao,
  TipoDocumentoResponsavelFinanceiro,
  TipoDocumentoTurmaCertificacao
} from 'src/tipos'

export enum TipoDocumentoUpload {
  RegistroCivil = 'Registro Civil (Sua Certidão de Nascimento ou Casamento)',
  Rg = 'RG ou CNH - Frente',
  RgVerso = 'RG ou CNH - Verso',
  Rne = 'Documento de Identidade / Passaporte / RNE',
  Cpf = 'CPF ou CNH',
  DiplomaGraduacao = 'Diploma de Graduação - Frente',
  DiplomaGraduacaoVerso = 'Diploma de Graduação - Verso',
  ComprovanteResidencia = 'Comprovante de Residência',
  CertificadoReservista = 'Certificado de Reservista',
  HistoricoEscolar = 'Histórico da Graduação',
  DiplomaTitulacaoMaxima = 'Diploma de Titulação Máx. - Frente',
  DiplomaTitulacaoMaximaVerso = 'Diploma de Titulação Máx. - Verso',
  RgCnh = 'RG/CNH - Frente',
  RgCnhVerso = 'RG/CNH - Verso',
  Identificacao = 'Documento de Identidade (ou CNPJ)',
  CertidaoNascimento = 'Certidão de nascimento do seu filho(a)',
  Logo = 'Logo',
  PPC = 'Projeto Pedagógico do Curso (PPC)'
}

export interface UploadDocumentos {
  id: number | string
  documentoId?: string
  nome?: string
  tipo:
    | TipoDocumentoAluno
    | TipoDocumentoProfessor
    | TipoDocumentoResponsavelFinanceiro
    | TipoDocumentoTurmaCertificacao
    | TipoDocumentoAlunoCertificacao
    | TipoDocumentoProfessorCertificacao
    | TipoDocumentoCursoCertificacao
    | TipoDocumentoParceiroCertificacao
  obrigatorio?: boolean
  dica?: string
  status: SituacaoUpload
  arquivo?: File
  editado?: boolean
  analisado?: boolean
  motivoDaRejeicao?: string
  dataPostagem?: string
  ordemExibicao: number
  dataConferencia?: string
  editarAprovado?: boolean
  motivoAlteracaoAprovado?: string
  multiplo?: boolean
  dataNascimento?: string
}

export interface AgregacaoDeUploads {
  edicoes: UploadDocumentos[]
  criacoes: UploadDocumentos[]
  analises?: UploadDocumentos[]
  contador: number
}
